export default "__VITE_ASSET__NfKuprBz__"